module.exports = __webpack_public_path__ + "img/logo-steam.81116cd2.svg";